"use client";

// global-error replaces the root layout entirely, so next-intl / Providers and
// the layout-injected fonts are unavailable here. Copy is hardcoded in German
// and styling stays self-contained.
import "./globals.css";

export default function GlobalError() {
  return (
    <html lang="de">
      <body>
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "2rem",
            background: "#fffbf5",
            color: "#2b2420",
            fontFamily: "system-ui, sans-serif",
            textAlign: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "1rem",
              maxWidth: "28rem",
            }}
          >
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img src="/error-heros.svg" alt="" width={224} height={149} />
            <h1 style={{ fontSize: "1.75rem", fontWeight: 800, margin: 0 }}>
              Da ist etwas schiefgelaufen
            </h1>
            <p style={{ color: "#6b6258", margin: 0 }}>
              Unsere Helden sind schon am Reparieren. Bitte lade die Seite neu.
            </p>
            {/* Full reload is intentional: the app crashed, so re-bootstrap it. */}
            {/* eslint-disable-next-line @next/next/no-html-link-for-pages */}
            <a
              href="/"
              style={{
                marginTop: "0.5rem",
                display: "inline-block",
                padding: "0.5rem 1rem",
                borderRadius: "0.5rem",
                background: "#e8820c",
                color: "#fff",
                textDecoration: "none",
                fontWeight: 600,
              }}
            >
              Zur Startseite
            </a>
          </div>
        </div>
      </body>
    </html>
  );
}
